import { createRouter, createWebHistory } from "vue-router";

// 公共路由
const public_router = [
  {
    path: "/",
    name: "root",
    redirect: () => {
      // PC端跳转到主题活动中心（未登录欢迎页），移动端跳转到登录页
      const isMobileDevice = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return isMobileDevice ? "/login" : "/themeActivityCenter";
    },
    meta: {
      navigator: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
    meta: {
      navigator: false,
    },
  },
  {
    path: "/errorPage",
    name: "errorPage",
    component: () => import("../views/errorPage.vue"),
    meta: {
      navigator: false,
    },
  },
  {
    path: "/tipsPage",
    name: "tipsPage",
    component: () => import("../views/tipsPage.vue"),
    meta: {
      navigator: false,
    },
  },
  {
    // 注册路由
    path: "/register",
    name: "register",
    component: () => import("../views/register/index.vue"),
    meta: {
      navigator: false,
      twoSided: true,
    },
  },
  {
    // 输入信息
    path: "/registerSignUp",
    name: "registerSignUp",
    component: () => import("../views/register/signUp.vue"),
    meta: {
      navigator: false,
      twoSided: true,
    },
  },
  {
    // 输入信息
    path: "/TestTracking",
    name: "TestTracking",
    component: () => import("../components/TestTracking.vue"),
    meta: {
      navigator: false,
      twoSided: true,
    },
  },
  {
    // 证书信息页面 - 允许匿名访问
    path: "/certificateInfo",
    name: "certificateInfo",
    component: () => import("../views/mobile/certificateInfo/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    // 问卷预览页面 - 允许匿名访问（移动端）
    path: "/questionnaire/preview/:templateCode",
    name: "questionnairePreviewMobile",
    component: () => import("../views/mobile/QuestionnairePreview.vue"),
    meta: {
      isMobile: true,
      navigator: false,
      twoSided: true,  // 允许PC和移动端都访问
    },
  },
  // {
  //   // 输入信息
  //   path: "/FaceDetection",
  //   name: "FaceDetection",
  //   component: () => import("../components/FaceDetection.vue"),
  //   meta: {
  //     navigator: false,
  //     twoSided: true,
  //   },
  // },
];

// PC路由
const pc_routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("../views/pc/home.vue"),
    meta: {
      isMobile: false,
      navigator: true,
    },
  },
  {
    path: "/signUp",
    name: "signUp",
    component: () => import("../views/pc/signUp.vue"),
    meta: {
      isMobile: false,
      navigator: false,
    },
  },
  {
    path: "/curriculum",
    name: "curriculum",
    component: () => import("../views/pc/curriculum/index.vue"),
    meta: {
      isMobile: false,
      navigator: true,
    },
  },
  {
    path: "/curriculumDetails",
    name: "curriculumDetails",
    component: () => import("../views/pc/curriculum/curriculumDetails.vue"),
    meta: {
      isMobile: false,
      navigator: true,
    },
  },
  {
    path: "/examination",
    name: "examination",
    component: () => import("../views/pc/examination/index.vue"),
    meta: {
      isMobile: false,
      navigator: true,
    },
  },
  {
    path: "/examinationDetails",
    name: "examinationDetails",
    component: () => import("../views/pc/examination/examinationDetails.vue"),
    meta: {
      isMobile: false,
      navigator: false,
    },
  },
  {    path: "/certificate",    name: "certificate",    component: () => import("../views/pc/certificate/index.vue"),    meta: {      isMobile: false,      navigator: true,    },  },
  {
    path: "/themeActivityCenter",
    name: "themeActivityCenter",
    component: () => import("../views/pc/themeActivityCenterCopy.vue"),
    meta: {
      isMobile: false,
      navigator: false,
    },
  },
  {    path: "/themeActivityCenterCopy",    name: "themeActivityCenterCopy",    component: () => import("../views/pc/themeActivityCenterCopy.vue"),    meta: {      isMobile: false,      navigator: true,    },  },
];

// 移动端路由
const mobile_router = [
  {
    path: "/operation",
    name: "operation",
    component: () => import("../views/mobile/operation.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/mobileHomev1",
    name: "mobileHomev1",
    component: () => import("../views/mobile/mobileHome.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/mobileHome",
    name: "mobileHome",
    component: () => import("../views/mobile/examList/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/mobileCurriculum",
    name: "mobileCurriculum",
    component: () => import("../views/mobile/mobileCurriculum.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/mobileExamination",
    name: "mobileExamination",
    component: () => import("../views/mobile/mobileExamination.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  // {
  //   path: "/examList",
  //   name: "examList",
  //   component: () => import("../views/mobile/examList/index.vue"),
  //   meta: {
  //     isMobile: true,
  //     navigator: false,
  //   },
  // },
  {
    path: "/courseDetail",
    name: "courseDetail",
    component: () => import("../views/mobile/courseDetail/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/userInfo",
    name: "userInfo",
    component: () => import("../views/mobile/userInfo/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/chooseEnterprise",
    name: "chooseEnterprise",
    component: () => import("../views/mobile/chooseEnterprise/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/addEnterprise",
    name: "addEnterprise",
    component: () => import("../views/mobile/addEnterprise/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },
  {
    path: "/wrongQuestion",
    name: "wrongQuestion",
    component: () => import("../views/mobile/wrongQuestion/index.vue"),
    meta: {
      isMobile: true,
      navigator: false,
    },
  },

];

const routes = public_router.concat(pc_routes.concat(mobile_router));
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
const isMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)
  ? true
  : false;
  //本地测试 微信公众号环境
const isProductionWeixin =
  navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
    ? true
    : false;
const isWeixin=process.env.NODE_ENV == "production"?isProductionWeixin:true

const loginInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
let hasRehydratedLogin = false;
router.beforeEach((to, from, next) => {
  // 首次进入时尝试从 localStorage 恢复 30 天内的登录态
  if (!hasRehydratedLogin) {
    try {
      const persisted = localStorage.getItem('persistUser');
      console.log('persisted',persisted)
      if (persisted) {
        const parsed = JSON.parse(persisted);
        if (parsed && parsed.expiresAt && parsed.data && parsed.expiresAt > Date.now()) {
          sessionStorage.setItem('userInfo', JSON.stringify(parsed.data));
        } else {
          // 超过 30 天或结构异常，清理本地保存
          localStorage.removeItem('persistUser');
          sessionStorage.removeItem('userInfo');
        }
      }
    } catch (e) {
      // ignore parse errors
    }
    hasRehydratedLogin = true;
  }

  if (to.path === "/errorPage") {
    next();
  } else {
    if (to.name != "login") {
      // certificateInfo、themeActivityCenter、questionnairePreviewMobile 等路由允许匿名访问
      if (
        to.name === "certificateInfo" ||
        to.name === "themeActivityCenterCopy" ||
        to.name === "themeActivityCenter" ||
        to.name === "questionnairePreviewMobile"
      ) {
        next();
        return;
      }
      
      // 未登录或登录已过期，统一跳转登录页
      const hasUser = !!sessionStorage.getItem('userInfo');
      if (!hasUser) {
        next({ path: '/login' });
        return;
      }
      // 禁止跨端访问
      if (isMobile && !isWeixin) {
        if (isMobile && !isWeixin) {
          next({
            path: "/errorPage",
          });
        } else if (isMobile && !to.meta.isMobile && !to.meta.twoSided) {
          //  if (isMobile && !to.meta.isMobile && !to.meta.twoSided) {
          next({
            path: "/mobileHome",
          });
        } else if (!isMobile && to.meta.isMobile && !to.meta.twoSided) {
          next({
            path: "/home",
          });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      // 若已登录，访问登录页则直接进入对应首页（移动端进入考试列表，PC 进入首页）
      const userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        next({ path: isMobile ? '/mobileHome' : '/home' });
      } else {
        next();
      }
    }
  }
});

export default router;